const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const get = require('lodash/object/get');
// @ helpers
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { RadioButton } = require('commonsComponents/radioButton');

const CoHolderRow = props => {
    const { coHolder, coHolderAccount, coHolderSelected, onHandleHolderRadioSelect } = props;

    const id = get(coHolder, 'identifDocumento.tipodocumentoofic', '') + '-' + get(coHolder, 'identifDocumento.codigodedocumento', '') + '|' + get(coHolder, 'identifPersona.codigodepersona', '') + '|' + coHolderAccount.getIn(['cnuevo','numerodecontrato'], '');
    const amountFormatted  = formatAmount(coHolderAccount.getIn(['saldoActual','importe'], ''));
    const currencyFormatted  = formatCurrency(coHolderAccount.getIn(['saldoActual','divisa'], ''));

    return (
        <OKTableRow>
            <OKTableCell className="mortgage-request-co-holder-view__table-cell--centered">
                <RadioButton
                    name="coHolderId"
                    isChecked={coHolderSelected === id}
                    inline={false}
                    onChange={onHandleHolderRadioSelect}
                    id={"coHolderId_option_"+id}
                    value={id}
                    label="&nbsp;"
                    className="mortgage-request-co-holder-view__choose-radio-button"
                />
            </OKTableCell>
            <OKTableCell>
                {get(coHolder, 'nomInterviniente', '')}
            </OKTableCell>
            <OKTableCell>
                {coHolderAccount.getIn(['cnuevo','numerodecontrato'], '')}
            </OKTableCell>
            <OKTableCell>
                {get(coHolder, 'tipoIntervencion', '')}
            </OKTableCell>
            <OKTableCell className="mortgage-request-co-holder-view__table-cell--bold">
                <span className="mortgage-request-co-holder-view__amount">
                    {amountFormatted}
                </span>
                &nbsp;
                <span className="mortgage-request-co-holder-view__currency">
                    {currencyFormatted}
                </span>
            </OKTableCell>
        </OKTableRow>
    );
};

CoHolderRow.propTypes = {
    coHolder: PropTypes.object,
    coHolderAccount: PropTypes.object,
    coHolderSelected: PropTypes.string,
    onHandleHolderRadioSelect: PropTypes.func
};

module.exports = CoHolderRow;
